import { Component, NgModule, Input, ElementRef, ViewChild, SimpleChanges, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { SharedService } from "./shared.service";
import { User, WorkloadTable, Week, UserFeatures } from './model/model.class';
import { Labels } from './model/language.model.class';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'kpi-component',
  templateUrl: './kpi.component.html',
  styleUrls: ['./kpi.component.css']
})

export class KpiComponent {

  @Input() accounId: string;
  @Input() user: User;
  @Input() labels: Labels;
  @ViewChildren(BaseChartDirective) charts: QueryList<BaseChartDirective>;

  distributionstats: any[];
  planadherencestats: any[];
  visitedCustomersInAlarm: any[];

  balances: any[];

  public chartPlugins = [pluginDataLabels];

  public pieChartType;
  public pieChartLegend;
  public pieChartLabels: any;
  public pieBackgroundColor: any;
  public pieChartColors: any;
  public pieChartData: any[];

  public customersVisitedInAlarmBarChartType;
  public customersVisitedInAlarmBarChartLegend;
  public customersVisitedInAlarmBarChartLabels: any;
  public customersVisitedInAlarmBarBackgroundColor: any;
  public customersVisitedInAlarmBarChartColors: any;
  public customersVisitedInAlarmBarChartData: any[];

  public routePlanAdherenceBarChartType;
  public routePlanAdherenceBarChartLegend;
  public routePlanAdherenceBarChartLabels: any;
  public routePlanAdherenceBarBackgroundColor: any;
  public routePlanAdherenceBarChartColors: any;
  public routePlanAdherenceBarChartData: any[];

  public userFeatures;

  public chartRefresh: boolean = true;  
      
  constructor(private sharedService: SharedService, private cdRef: ChangeDetectorRef) {
    let that = this;

    that.pieBackgroundColor = {
      "1W": "#699BD0",
      "2W": "#B02418",
      "4W": "#7EAA55",
      "8W": "#F6C142",
      "Other": "#4E73BE",
      "Not Planned": "#A5A5A5"
    };

    this.sharedService.distributionstatsEvent.subscribe(distributionstatsData => {
      let distributionstats = distributionstatsData.distributionstats;
      this.distributionstats = distributionstats;

      this.distributionstatsStructureManipulation();
    });

    this.sharedService.planadherencestatsEvent.subscribe(planadherencestatsData => {
      let planadherencestats = planadherencestatsData.planadherencestats;
      this.planadherencestats = planadherencestats;
      this.visitedCustomersInAlarm = planadherencestats['AlarmLevels'];

      this.visitedCustomersInAlarmStructureManipulation();
      this.planadherencestatsStructureManipulation();
    });

    this.sharedService.userEvent.subscribe(data => {
      this.distributionstats = undefined;
      this.planadherencestats = undefined;
      this.visitedCustomersInAlarm = undefined;
    });

    this.userFeatures = [];
  }

  ngOnInit() {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));

    if(currentUser && currentUser.userTypes && currentUser.userTypes.length > 0) {
      this.userFeatures = this.sharedService.getTextualFunctionality(currentUser);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['labels']) {
        this.reinitializeComponent();
    }
  }

  private reinitializeComponent() {

    if ((this.visitedCustomersInAlarm != undefined) && (this.planadherencestats != undefined)) {
      this.visitedCustomersInAlarmStructureManipulation();
      this.planadherencestatsStructureManipulation();
    }

    if ((this.distributionstats != undefined))
      this.distributionstatsStructureManipulation();

  }
 
  private distributionstatsStructureManipulation() {

    let that = this;
    let weeks = that.distributionstats['workload']['Weeks'];
    let days;
    let dayOfWeek;
    that.balances = [];

    for (let x = 0; x < 7; x++) {
      that.balances[x] = [];
      dayOfWeek = x + 1;

      for (let i = 0; i < weeks.length; i++) {
        days = weeks[i]['Days'];
        let notPresent = true;
        for (let y = 0; y < days.length; y++) {
          if (days[y]['DayOfWeek'] === dayOfWeek) {
            notPresent = false;
            that.balances[x].push(days[y]);
          }
        }
        if (notPresent)
          that.balances[x].push({});

        that.balances[x]['DayOfWeek'] = that.DaysTranslation(dayOfWeek);
      }
    }

    that.pieChartType = 'pie';
    that.pieChartLegend = true;
    that.pieChartLabels = [];
    that.pieChartColors = [];
    that.pieChartData = [];

    that.pieChartColors.push({
      "backgroundColor": [
      ]
    })

    let visitFrequencyDistribution = that.distributionstats['VisitFrequencyDistribution'];
    that.pieChartLabels = visitFrequencyDistribution.map(vfd => that.VisitFrequencyTranslation(vfd['Key']));
    that.pieChartData = visitFrequencyDistribution.map(vfd => vfd['Value']);
    that.pieChartColors = [{
      backgroundColor: visitFrequencyDistribution.map(vfd => that.pieBackgroundColor[vfd['Key']])
    }];
    this.chartRefresh = false;
    setTimeout(() => this.chartRefresh = true, 0);

  }

  private visitedCustomersInAlarmStructureManipulation() {
    let that = this;

    that.customersVisitedInAlarmBarChartType = 'bar';
    that.customersVisitedInAlarmBarChartLegend = true;
    that.customersVisitedInAlarmBarChartLabels = [];
    that.customersVisitedInAlarmBarChartColors = [];
    that.customersVisitedInAlarmBarChartData = [];
    that.customersVisitedInAlarmBarBackgroundColor = {};
    const visitedString = that.labels.CustomersVisitedInAlarmBarChart['legend']['VISITED'];
    const notVisitedString = that.labels.CustomersVisitedInAlarmBarChart['legend']['NOT VISITED'];
    that.customersVisitedInAlarmBarBackgroundColor[visitedString] = "#7EAA55";
    that.customersVisitedInAlarmBarBackgroundColor[notVisitedString] = "#B02418";

    that.customersVisitedInAlarmBarChartColors = [
      { backgroundColor: that.customersVisitedInAlarmBarBackgroundColor[that.labels.CustomersVisitedInAlarmBarChart['legend']['VISITED']] },
      { backgroundColor: that.customersVisitedInAlarmBarBackgroundColor[that.labels.CustomersVisitedInAlarmBarChart['legend']['NOT VISITED']] }
    ];

    that.customersVisitedInAlarmBarChartLabels = [];

    that.customersVisitedInAlarmBarChartData = [
      {
        data: [],
        label: that.labels.CustomersVisitedInAlarmBarChart['legend']['VISITED'],
        stack: '1'
      },
      {
        data: [],
        label: that.labels.CustomersVisitedInAlarmBarChart['legend']['NOT VISITED'],
        stack: '1'
      }
    ];

    const notDefined = "N/D";
    for (let i = 0; i < that.visitedCustomersInAlarm.length; i++) {
      // this is not considered as a true alarm
      if (that.visitedCustomersInAlarm[i].Type === 100) continue;

      const label = that.CustomersVisitedInAlarmTranslation(that.visitedCustomersInAlarm[i].Type);
      const visitedStr = that.visitedCustomersInAlarm[i].Visited;
      const notVisitedStr = that.visitedCustomersInAlarm[i].NotVisited;

      that.customersVisitedInAlarmBarChartLabels.push(label ? label : notDefined);
      that.customersVisitedInAlarmBarChartData[0].data.push(visitedStr !== null ? visitedStr : notDefined);
      that.customersVisitedInAlarmBarChartData[1].data.push(notVisitedStr !== null ? notVisitedStr : notDefined);
    }
  }

  private planadherencestatsStructureManipulation() {
    let that = this;

    that.routePlanAdherenceBarChartType = 'bar';
    that.routePlanAdherenceBarChartLegend = true;
    that.routePlanAdherenceBarChartLabels = [];
    that.routePlanAdherenceBarChartColors = [];
    that.routePlanAdherenceBarChartData = [];
    that.routePlanAdherenceBarBackgroundColor = {};
    const visitedString = that.labels.CustomerStatusAdherenceBarChart['legend']['VISITED'];
    const notVisitedString = that.labels.CustomerStatusAdherenceBarChart['legend']['NOT VISITED'];
    that.routePlanAdherenceBarBackgroundColor[visitedString] = "#7EAA55";
    that.routePlanAdherenceBarBackgroundColor[notVisitedString] = "#B02418";

    const newLabels = [
      that.CustomerStatusAdherenceTranslation('ACTIVE'),
      that.CustomerStatusAdherenceTranslation('ZERO'),
      that.CustomerStatusAdherenceTranslation('PROSPECT')
    ];


    that.routePlanAdherenceBarChartLabels = newLabels.slice();    
    that.routePlanAdherenceBarChartColors = [
      { backgroundColor: that.routePlanAdherenceBarBackgroundColor[that.labels.CustomerStatusAdherenceBarChart['legend']['VISITED']] },
      { backgroundColor: that.routePlanAdherenceBarBackgroundColor[that.labels.CustomerStatusAdherenceBarChart['legend']['NOT VISITED']] }
    ];
    that.routePlanAdherenceBarChartData = [
      {
        data: [
          that.planadherencestats['ActiveVisited'],
          that.planadherencestats['ZeroVisited'],
          that.planadherencestats['ProspectVisited']
        ],
        label: that.labels.CustomerStatusAdherenceBarChart['legend']['VISITED'],
        stack: '1'
      },
      {
        data: [
          that.planadherencestats['ActivePlanned'],
          that.planadherencestats['ZeroPlanned'],
          that.planadherencestats['ProspectPlanned']
        ],
        label: that.labels.CustomerStatusAdherenceBarChart['legend']['NOT VISITED'],
        stack: '1'
      }
    ];

    //#region Workaround for Angular 4.0: forces labels to update dynamically when they change

    const newChartObj = Object.assign({}, {
      labels: this.routePlanAdherenceBarChartLabels,
      datasets: this.routePlanAdherenceBarChartData
    });

    this.routePlanAdherenceBarChartLabels = newChartObj.labels;
    this.routePlanAdherenceBarChartData = newChartObj.datasets;

    this.cdRef.detectChanges();

    if (this.charts) {
      this.charts.forEach(c => {
        if (c.chart) {
          c.chart.destroy();  
          c.chart = null;     
          c.ngOnInit();       
        }
      });
    }
    //#endregion 

  }
  
  public pieChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'right',
      /*labels: {
        fontColor: 'rgb(255, 99, 132)'
      }*/
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let datasets = ctx.chart.data.datasets;

          let sum = datasets[0].data.reduce((a, b) => a + b, 0);
          let percentage = Math.round((value / sum) * 100) + '%'; 
          return value + ' (' + percentage + ')';
        },
        color: '#fff'/*,
        font: {
          weight: 'bold',
          size: 16,
        }*/
      }
    }
  };

  public barChartOptions: any = {
    responsive: true,
    scales: {
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false
        },
        ticks: {
          display: true,
          fontSize: 8
        }
      }],
      yAxes: [{
        stacked: true,
        gridLines: {
          display: false
        },
        ticks: {
          display: false,
          ticks: {
            beginAtZero: true
          }
        }
      }]
    },
    legend: {
      position: 'top'
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          let datasets = ctx.chart.data.datasets;

          let sumVerticalLineBarTemp = []
          for (let i = 0; i < datasets.length; i++) {
            for (let y = 0; y < datasets[i].data.length; y++) {
              sumVerticalLineBarTemp[y] ? sumVerticalLineBarTemp[y] += datasets[i].data[y] : sumVerticalLineBarTemp[y] = datasets[i].data[y];
            }
          }

          let percentage = Math.round((value / sumVerticalLineBarTemp[ctx.dataIndex]) * 100) + '%';
          return value != '0' ? value + ' (' + percentage + ')' : "0";
        },
        color: '#fff'/*,
        font: {
          weight: 'bold',
          size: 16,
        }*/
      }
    }
  };

  onChartClick(event) {
    console.log(event);
  }

  private OpenTab(tabView) {
    this.sharedService.SwitchTab(tabView);
  }

  private DaysTranslation(visitDay) {
    return this.labels.Days[visitDay];
  }

  private VisitFrequencyTranslation(visitFrequency) {
    return this.labels.VisitFrequencyPieChart['frequency'][visitFrequency];
}

  private CustomerStatusAdherenceTranslation(customerStatusAdherence) {
    return this.labels.CustomerStatusAdherenceBarChart['state'][customerStatusAdherence];
  }

  private CustomersVisitedInAlarmTranslation(customersVisitedInAlarm) {
    return this.labels.CustomersVisitedInAlarmBarChart['state'][customersVisitedInAlarm];
  }

}



// WEBPACK FOOTER //
// ./src/app/kpi.component.ts